var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FA_SPINNER } from '../../../const/iconProps';
import { colors } from '../../../defaultTheme';
const SpinnerAnimation = keyframes `
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const LoadingWrapper = styled.div `
  svg,
  png,
  jpg {
    animation: ${SpinnerAnimation} 1s linear infinite;
  }
`;
const SpinnerLoader = (_a) => {
    var { color = colors.grey, size, icon = (React.createElement(FontAwesomeIcon, { icon: FA_SPINNER, title: "Content Loading", color: color, size: size })), className, ariaLabel = 'Content Loading' } = _a, props = __rest(_a, ["color", "size", "icon", "className", "ariaLabel"]);
    return (React.createElement(LoadingWrapper, Object.assign({ className: className }, props, { "aria-label": ariaLabel }), icon));
};
export default SpinnerLoader;
